import { ActionsService } from '../resources/actions.service';
import { Model } from '../common/model';
import { Observable } from 'rxjs';

export class ActionModel extends Model {
  public activate(): Observable<any> {
    return this.actionsService.post(this._id + '/activate');
  }

  get name(): string {
    return this._data.name;
  }

  set name(value: string) {
    this._data.name = value;
  }

  get expr(): any {
    return this._data.expr;
  }

  set expr(value: any) {
    this._data.expr = value;
  }

  get meta(): any {
    return this._data.meta;
  }

  set meta(value: any) {
    this._data.meta = value;
  }

  get ownerId(): any {
    return this._data.ownerId;
  }

  set ownerId(value: any) {
    this._data.ownerId = value;
  }

  constructor(protected actionsService: ActionsService, data: any) {
    super(actionsService, data);
  }
}
